import {
  usedCarsAPI,
  CAR_OFFERS_URL,
  COUNTY_LIST_URL,
  MAX_PRICE_RANGE
} from "@/api";
import {
  UPDATE_DATA,
  UPDATE_MAX_PRICE_RANGE,
  UPDATE_REGIONS
} from "@/store/mutationTypes";
import {
  GET_DATA_FROM_API,
  GET_MAX_PRICE_RANGE,
  UPDATE_REGIONS_LIST
} from "@/store/actionTypes";
import { options } from "@/store/options";

export default {
  async [GET_DATA_FROM_API]({ state, commit }) {
    const {
      dealerLocations,
      models,
      year,
      transmission,
      fuelType,
      paymentType,
      priceRange,
      ordering,
      prices: { lowest: minCarPrice, heighest: maxCarPrice }
    } = state;

    const response = await usedCarsAPI().get(CAR_OFFERS_URL, {
      params: {
        seller: dealerLocations.join(),
        model_body: models.join(),
        year_min: year.from,
        year_max: year.to,
        gearbox: transmission.join(),
        fuel: fuelType.join(),
        monthly_min: paymentType === "monthly" ? priceRange.monthly.min : "",
        monthly_max: paymentType === "monthly" ? priceRange.monthly.max : "",
        price_min:
          paymentType === "car-price"
            ? priceRange.carPrice.min || minCarPrice
            : "",
        price_max:
          paymentType === "car-price"
            ? priceRange.carPrice.max || maxCarPrice
            : "",
        page_size: options.getCarsPerPage(),
        ordering
      }
    });

    commit(UPDATE_DATA, response.data);
  },

  async [UPDATE_REGIONS_LIST]({ commit }) {
    const response = await usedCarsAPI().get(COUNTY_LIST_URL);

    commit(UPDATE_REGIONS, response.data);
  },

  async [GET_MAX_PRICE_RANGE]({ commit }) {
    const response = await usedCarsAPI().get(MAX_PRICE_RANGE);

    commit(UPDATE_MAX_PRICE_RANGE, response.data);
  }
};
